var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineJudge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m19.48 19.04-4.95-4.95a.754.754 0 0 1 0-1.06c.29-.29.77-.29 1.06 0l4.95 4.95c.29.29.29.77 0 1.06-.15.15-.34.22-.53.22s-.38-.07-.53-.22z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.17 17.62-4.24-4.24a2.758 2.758 0 0 1 0-3.89L11 2.42a2.758 2.758 0 0 1 3.89 0l4.24 4.24a2.732 2.732 0 0 1 0 3.88l-7.07 7.07c-.52.54-1.21.82-1.95.82-.73 0-1.43-.29-1.94-.81zm3.89-14.13-7.07 7.07a1.25 1.25 0 0 0 0 1.77l4.24 4.24c.47.47 1.29.47 1.77 0l7.07-7.07a1.234 1.234 0 0 0 0-1.76L13.83 3.5a1.22 1.22 0 0 0-.89-.38c-.32 0-.64.12-.88.37z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 21.75c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h6c.41 0 .75.34.75.75s-.34.75-.75.75H2zM13.1 15.52 6.03 8.45a.754.754 0 0 1 0-1.06c.29-.29.77-.29 1.06 0l7.07 7.07c.29.29.29.77 0 1.06-.14.15-.34.22-.53.22s-.38-.07-.53-.22z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineJudge);
export default __webpack_public_path__ + "static/media/vuesax-outline-judge.e727e6474d67aa201d74228689465d35.svg";
export { ForwardRef as ReactComponent };